// @ts-expect-error: Flow to TS migration.
type Record<T, V> = Partial<Record<T, V>>

type Value = string | number

// @ts-expect-error: Flow to TS migration.
export type Values = Record<string, Value>
export type Options = {
  defaultMessage?: string
}
export type Translate = (key: string, values?: Values, opts?: Options) => string
// @ts-expect-error: Flow to TS migration.
export type Translations = Record<string, string>

export function translate(
  translations: Translations,
  key: string,
  values: Values = {},
  opts: Options = {},
) {
  const fallback = opts.defaultMessage == null ? null : opts.defaultMessage
  const translation = key in translations ? translations[key] : fallback
  if (translation == null) {
    return key
  }

  return Object.keys(values).reduce(
    (acc, placeholder) =>
      acc
        .replace(new RegExp(`__${placeholder}__`, "g"), String(values[placeholder])) // for cases where Nitro's currency format is passed as key
        .replace(new RegExp(`{${placeholder}}`, "g"), String(values[placeholder])), // for icu translations
    translation,
  )
}

export default translate
